<template>
    <div>
        <div v-for="(faq, index) in faqItems" :key="index">
            <a :id="'anch_answer' + faq.id">
                <div class="faq">
                    <p class="question" @click="toggleAnswer(faq)">
                        {{ faq.q }}
                        <span class="toggleIcon">
                            {{ faq.isOpen ? "-" : "＋" }}
                        </span>
                    </p>
                    <p class="answer" :ref="'answer' + faq.id" :id="'answer' + faq.id" v-html="faq.a"></p>


                </div>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        mode: String
    },
    data() {
        return {
            password1: "",
            faqItems: [
                {
                    id: 1,
                    q: "Who is Your Insurance?",
                    a: `<p>Your Insurance is an insurtech offering technology,
                        advisory, and marketing solutions to the insurance and
                        finance sectors, including brokers, lenders and dealers.</p>
                        <p>
                        Our focus is on designing innovative technology
                        solutions to elevate business value and foster growth for
                        our partners.</p>
                        
                        `,
                    isOpen: false
                },
                {
                    id: 2,
                    q: "Our Products",
                    a: `<p>Your Insurance offers instant access to insurance for:</p>
<ul class="supportList">
<li>Unregistered mobile plant and machinery</li>

<li>Light machinery</li>

    </ul>

<p>The process is fast, simple, and efficient.</p>

<p><b>Choose from 2 options:</b></p>

 <ol class="supportList">
    <li><b>Use Your Insurance’s trusted insurance partners:</b> Your Insurance has partnered with some of the largest and most respected General Insurance businesses in Australia and New Zealand.</li>
    <li><b>Select your own trusted insurance partner</b> – Already work with an insurance broker?  No problem.  The Your Insurance platform can link directly to your insurance broker of choice.</li>
 </ol>   
`,
                    isOpen: false
                },
                {
                    id: 3,
                    q: "Who is Insurance Advisernet?",
                    a: `<p>Insurance Advisernet was founded in 1996 to provide high-quality risk management advice that business owners can trust.</p>
                        <p>Today, they are one of the largest and most respected General Insurance businesses in Australia and New Zealand, with an ever-growing network of over 270 insurance advice practices across 150 locations.</p>`,
                    isOpen: false
                },
                {
                    id: 4,
                    q: "Login Page",
                    a: `<p>Sign in at https://partner.yourinsurancehq.com.au/login</p> 
                    <p>Click Remember Me so your details will be saved.</p>  
                    <p>Click Forgot Password if you do not know your login details and an email will be sent to you to reset your password.</p>
                        <p>
                            <img width="600px" class="digger" src="/img/support/login-page.png" />
                        </p>`,
                    isOpen: false
                },
                {
                    id: 5,
                    q: "Home Page",
                    a: `<p>Click create quote under the Plant & Equipment link and enter your customer contact information. </p>

<p>The Dashboard will show Announcements and Statistics regarding your account including the number of quotes and number of policies placed.</p>

<p>Ongoing quotes can be found under the Quotes link and bound policies under the Policies link.</p>

<p>To find a policy or quote, please use the reports functionality.</p>
                        <p>
                            <img width="600px" class="digger" src="/img/support/home-page.png" />
                        </p>`,
                    isOpen: false
                },
                {
                    id: 6,
                    q: "Create a Quote for an instant indicative premium",
                    a: `<p>Click create quote under the Plant & Equipment link and enter your customer contact information. </p>
<p>Just four quick data inputs are needed to generate a live quote. </p>
 
                        <p>
                            <img width="600px" class="digger" src="/img/support/indicative-premium-1.png" />
                        </p>
                        <p>A live quote is generated which can be sent directly to your client or your preferred insurance broker for execution via the portal.</p>
                        <p>
                            <img width="600px" class="digger" src="/img/support/indicative-premium-2.png" />
                        </p>
                        `,
                    isOpen: false
                },
                {
                    id: 7,
                    q: "Customer/Broker Emails",
                    a: `<p>Your client/broker will receive an email with a link directing them to confirm a bit more information and then the quote will be bound. </p>

<p>You will be kept informed via email for a smooth client experience.   </p>
                        <p>
                            <img width="600px" class="digger" src="/img/support/customer-broker-emails.png" />
                        </p>`,
                    isOpen: false
                },
                //                 {
                //                     id: 8,
                //                     q: "Broker Email",
                //                     a: `<p>An email will be sent directly to you summarising the quote detail just entered.</p>
                //                     <p>If any changes need to be made, contact Insurance Advisernet directly at: </p>
                //                         <p>service@insadviser.net.au</p>
                //                         <p>
                //                             <img width="600px" class="digger" src="/img/support/broker-email.png" />
                //                         </p>
                // `,
                //                     isOpen: false
                //                 },
                {
                    id: 8,
                    q: "Reports",
                    a: `<p>By clicking the Reports link you can search, sort and filter on all your policies.</p>
                    <p>There is the option to Export your data via CSV file. </p>
                    <p>
                            <img width="600px" class="digger" src="/img/support/reports1.png" />
                        </p>`,
                    isOpen: false
                },
                {
                    id: 9,
                    q: "Support",
                    a: `<p>
                            Your Insurance<br/>
                            <a href="mailto:support@yourinsurancehq.com.au">support@yourinsurancehq.com.au</a>
                        </p>
                        <p>
                            Insurance Advisernet<br/>
                            <a href="mailto:service@insadviser.net.au">service@insadviser.net.au</a>
                        </p>`,
                    isOpen: false
                }
            ]
        };
    },
    methods: {
        toggleAnswer(_faq) {
            console.log(_faq.isOpen);

            if (_faq.isOpen == false) {
                _faq.isOpen = true;
                this.expand("answer" + _faq.id);
            } else {
                this.collapse("answer" + _faq.id);
                _faq.isOpen = false;
            }




        },
        collapse(refItem) {
            // select the answer element

            const answer = this.$refs[refItem][0];

            // set its height to its normal scroll height to expand it fully
            answer.style.height = 0;
        },
        expand(refItem) {
            // select answer element
            for (let i = 1; i <= 9; i++) {
                this.collapse("answer" + i.toString());
                this.faqItems[i - 1].isOpen = false;
            }


            const answer = this.$refs[refItem][0];

            // set its height to its normal scroll height to expand it fully
            answer.style.height = answer.scrollHeight + "px";
        },
        autoExpand(item) {
            setTimeout(() => {
                this.collapse(item);
                this.expand(item);
                var element_to_scroll_to = document.getElementById("anch_" + item);
                element_to_scroll_to.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
                // const target = document.getElementById(item);
                // const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
                // window.scrollTo({
                //     top: targetPosition,
                //     behavior: 'smooth'
                // });
            }, 200);

            setTimeout(() => {
                //this.collapse(item);
                //this.expand(item);
                // const target = document.getElementById(item);
                // const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
                // window.scrollTo({
                //     top: targetPosition,
                //     behavior: 'smooth'
                // });
                var element_to_scroll_to = document.getElementById("anch_" + item);
                element_to_scroll_to.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'end' });

            }, 400);
        }
    },
    mounted() {
        //this.expand("answer1");

        console.log(this.mode);

        var currentPage = document.location.href;
        console.log(currentPage);

        // if (this.mode == "modal") {
        //     if (currentPage.includes("/dashboard")) {

        //         this.autoExpand("answer5")

        //     } else if (currentPage.includes("/createQuote")) {

        //         this.autoExpand("answer6")

        //     } else  if (currentPage.includes("/quotes")) {

        //         this.autoExpand("answer13")

        //     } else if (currentPage.includes("/policies")) {

        //         this.autoExpand("answer16")

        //     } else {
        //         this.autoExpand("answer1")
        //     }
        // } else {
        this.autoExpand("answer1")
        //}
    },

    components: {
        //TextFooter
    }
};
</script>

<style lang="scss" scoped>
/* style the FAQ section */
.question {
    background: white;
    text-transform: uppercase;
    cursor: pointer;
    font-weight: bold;
    box-shadow: 0px 2px 2px 0 #88888855;
    padding: 10px 0;
    transition: transform 0.2s;
    position: relative;
    padding-left: 20px;
    color: red;
    border: 1px solid red;
}

.question:hover {
    background: white;
    color: red
}



/* styles when the question is clicked */
.question:active {
    transform: translateY(4px);
    box-shadow: none;
}

.answer {
    transition: 0.25s;
    /* smooth slide-in */
    height: 0;
    /* starts collapsed */
    overflow: hidden;
    line-height: 1.5;
    margin-bottom: 0px !important;
}



/* style the toggleIcon */
.toggleIcon {
    font-size: 1.5em;
    font-weight: bold;
    position: absolute;
    top: 18px;
    right: 20px;
    display: inline-block;
    line-height: 0.5;
    color: white;
}


</style>

<style>
.supportList li {
        margin-bottom: 6px !important;
}
</style>